module.exports = __webpack_public_path__ + "static/media/restorran_cover.49cbb89d.jpg";